import React from "react";

export const MdArrowDropup = () => (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M128 320l128-128 128 128z"/></svg>) as JSX.Element;
